import React from "react";

import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      Open-source code by{" "}
      <a href="https://github.com/tiggrra/dictionary-project" target="_blank" rel="noopener noreferrer">
        tiggrra
      </a>
    </div>
  )
}